/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplementStatus } from './SupplementStatus';
import {
    SupplementStatusFromJSON,
    SupplementStatusFromJSONTyped,
    SupplementStatusToJSON,
    SupplementStatusToJSONTyped,
} from './SupplementStatus';

/**
 * Payload to create a new supplement
 * @export
 * @interface CreateSupplementRequest
 */
export interface CreateSupplementRequest {
    /**
     * ID of the claim
     * @type {number}
     * @memberof CreateSupplementRequest
     */
    claimId: number;
    /**
     * ID of the comparison
     * @type {number}
     * @memberof CreateSupplementRequest
     */
    comparisonId: number;
    /**
     * 
     * @type {SupplementStatus}
     * @memberof CreateSupplementRequest
     */
    status?: SupplementStatus;
    /**
     * US state code (e.g., 'TX', 'AK') for building code justifications
     * @type {string}
     * @memberof CreateSupplementRequest
     */
    state: string;
    /**
     * Total amount requested in cents
     * @type {number}
     * @memberof CreateSupplementRequest
     */
    amountRequestedCents?: number | null;
    /**
     * Total amount approved in cents
     * @type {number}
     * @memberof CreateSupplementRequest
     */
    amountApprovedCents?: number | null;
    /**
     * Overall AI confidence score
     * @type {number}
     * @memberof CreateSupplementRequest
     */
    overallConfidenceScore?: number | null;
}



/**
 * Check if a given object implements the CreateSupplementRequest interface.
 */
export function instanceOfCreateSupplementRequest(value: object): value is CreateSupplementRequest {
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('comparisonId' in value) || value['comparisonId'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    return true;
}

export function CreateSupplementRequestFromJSON(json: any): CreateSupplementRequest {
    return CreateSupplementRequestFromJSONTyped(json, false);
}

export function CreateSupplementRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSupplementRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'claimId': json['claimId'],
        'comparisonId': json['comparisonId'],
        'status': json['status'] == null ? undefined : SupplementStatusFromJSON(json['status']),
        'state': json['state'],
        'amountRequestedCents': json['amountRequestedCents'] == null ? undefined : json['amountRequestedCents'],
        'amountApprovedCents': json['amountApprovedCents'] == null ? undefined : json['amountApprovedCents'],
        'overallConfidenceScore': json['overallConfidenceScore'] == null ? undefined : json['overallConfidenceScore'],
    };
}

export function CreateSupplementRequestToJSON(json: any): CreateSupplementRequest {
    return CreateSupplementRequestToJSONTyped(json, false);
}

export function CreateSupplementRequestToJSONTyped(value?: CreateSupplementRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'comparisonId': value['comparisonId'],
        'status': SupplementStatusToJSON(value['status']),
        'state': value['state'],
        'amountRequestedCents': value['amountRequestedCents'],
        'amountApprovedCents': value['amountApprovedCents'],
        'overallConfidenceScore': value['overallConfidenceScore'],
    };
}

